function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createSelector, createStructuredSelector } from 'reselect';
import { userIdSelector } from 'swag-client-common/redux/user/user.selectors';
import { featureTogglesSelector } from 'swag-client-common/redux/feature-toggles/feature-toggles.selectors';
import { activeProductImageSelector, logoSizeSelector, fullScreenModeSelector, viewTypeSelector, showMoreImageModeSelector, hasPreviewsSelector, isSamplePromoSelector, isToolsPanelButtonsShownSelector, isProductPrintingModeSelector, isRebuildModeSelector, sharedItemsSelector, isLimitedEditionSelector, isRebuildCBSProductModeSelector, isEmbellishmentMethodSelectedSelector, isCurrentViewValidSelector, productVariantsSelector, currentProductSettingsSelector } from '../../../../../../../redux/product/product.selectors';
import { currentViewLogosListSelector, fontsSelector, layersSelector } from '../../../../../../../redux/logo/logo.selectors';
import { getViewMediaList } from '../../../../../../../redux/logo/logo.utils';
const propsSelector = (_, props) => props;
const shouldShowImprintAreaSelector = createSelector(isProductPrintingModeSelector, isEmbellishmentMethodSelectedSelector, isCurrentViewValidSelector, featureTogglesSelector, (isProductPrintingMode, isEmbellishmentMethodSelected, isCurrentViewValid, {
  dynamicQuantityAndLocationsOptionsForDecorationMethods
}) => isProductPrintingMode && isCurrentViewValid && (!dynamicQuantityAndLocationsOptionsForDecorationMethods || isEmbellishmentMethodSelected));
const viewSelector = createSelector(propsSelector, props => props.view);
export const hiddenActiveProductImageSelector = createSelector(productVariantsSelector, propsSelector, currentProductSettingsSelector, featureTogglesSelector, (variants, props, currentProductSettings, {
  dynamicQuantityAndLocationsOptionsForDecorationMethods
}) => {
  var _variant$images$view;
  const {
    view
  } = props;
  const variant = variants.find(v => !v.isHidden && v.images[view]);
  if (!variant) {
    return null;
  }
  const variantImage = (_variant$images$view = variant.images[view]) === null || _variant$images$view === void 0 ? void 0 : _variant$images$view[0];
  if (!variantImage) {
    return null;
  }
  const editorImage = {
    id: view,
    url: variantImage.url,
    isImageWithImprintArea: true,
    embellishmentMethodId: null
  };
  if (!dynamicQuantityAndLocationsOptionsForDecorationMethods) {
    return _objectSpread({}, variantImage, editorImage);
  }
  const variantLocationsData = (currentProductSettings === null || currentProductSettings === void 0 ? void 0 : currentProductSettings.locations[variant.variantId]) || {};
  const locationData = variantLocationsData[view];
  if (!currentProductSettings || !locationData) {
    return editorImage;
  }
  return _objectSpread({}, editorImage, {
    name: locationData.name,
    size: locationData.size,
    rectangle: locationData.rectangle,
    embellishmentMethodId: currentProductSettings.embellishmentMethodId
  });
});
export const currentLogosBasedOnViewSelector = createSelector(layersSelector, propsSelector, (layers, {
  view
}) => {
  return getViewMediaList(layers, view);
});
export const makeProductEditorSelector = createStructuredSelector({
  productImage: activeProductImageSelector,
  isToolsPanelExists: isToolsPanelButtonsShownSelector,
  media: currentViewLogosListSelector,
  logoSize: logoSizeSelector,
  view: viewTypeSelector,
  isFullScreenMode: fullScreenModeSelector,
  showMoreImageMode: showMoreImageModeSelector,
  hasPreviews: hasPreviewsSelector,
  isSamplePromo: isSamplePromoSelector,
  fonts: fontsSelector,
  isLoggedIn: userIdSelector,
  shouldShowImprintArea: shouldShowImprintAreaSelector,
  isEditingSharedItem: createSelector(isRebuildModeSelector, sharedItemsSelector, (isEdit, sharedItems) => isEdit && sharedItems.length > 0),
  isLimitedEdition: isLimitedEditionSelector,
  isLogoControlsDisabled: isRebuildCBSProductModeSelector
});
export const hiddenProductEditorSelector = createStructuredSelector({
  productImage: hiddenActiveProductImageSelector,
  media: currentLogosBasedOnViewSelector,
  fonts: fontsSelector,
  view: viewSelector,
  logoSize: () => null,
  isToolsPanelShown: () => false,
  isFullScreenMode: () => false,
  showMoreImageMode: () => false,
  isLogoControlsDisabled: () => false
});